<template>
    <div>
        <vx-input-group class="mb-base" prependClasses="border border-solid border-grey border-r-0">
            <template slot="prepend">
                <div class="prepend-text">
                    <vs-dropdown vs-custom-content vs-trigger-click>
                        <vs-button class="flex items-center" style="height: 30px" color="dark" type="flat" href.prevent>
                            <span>
                                {{ $t(listTypeFind.find(e => e.value === typeFind).nameI18n) }}
                            </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1" />
                        </vs-button>

                        <vs-dropdown-menu class="dropdown-login">
                            <vs-dropdown-item v-for="type in listTypeFind"
                                              @click="setType(type.value)"
                                              :key="type.nameI18n">
                                {{ $t(type.nameI18n) }}
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </template>

            <vs-input v-model="input"
                     
                      @change="inInput"
                      :placeholder="$t('input_write_for_find')"/>
        </vx-input-group>
    </div>
</template>

<script>
import debounce from 'lodash.debounce';
export default {
    name: "Find",
    data(){
        return {
            input: '',
            typeFind: 'full_name',
            listTypeFind: [
                {
                    nameI18n: 'full_name',
                    value: 'full_name'
                },
                {
                    nameI18n: 'educational_program',
                    value: 'education_program'
                },
                {
                    nameI18n: 'education_program_group_name',
                    value: 'education_program_group'
                }
            ]
        }
    },
    methods: {
        setQueryParams(){
            this.$router.replace({
                name: this.$route.name,
                query: {
                    type: this.typeFind,
                    search_text: this.input
                }
            })
        },
        setType(value){
            this.typeFind = value;

            if (this.input)
                this.setQueryParams()
        },
        inInput: debounce(function (){
            this.setQueryParams()
        }, 1000)
    },
    watch: {
        '$route.query':{
            handler(){
                if (!this.$route.query['search_text']){
                    this.input = ''
                }
            },
            deep: true,
        }
    }
}
</script>

<style scoped lang="scss">

</style>
